import React from 'react';
import { Container } from 'react-bootstrap';

export default function Footer() {
  return (
    <footer
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        borderTop: '1px solid rgba(255, 255, 255, 0.08)',
        padding: '1.5rem 0',
        marginTop: 'auto',
        boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.7)'
      }}
    >
      <Container>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '0.75rem'
          }}
        >
          <p
            style={{
              margin: 0,
              color: '#d4d4d4',
              fontFamily: "'Roboto', sans-serif",
              fontSize: '0.9rem',
              textAlign: 'center'
            }}
          >
            <span style={{ color: '#c9a961', fontWeight: '600' }}>Discord:</span> shireenkhan#7710
            {' '} | {' '}
            <span style={{ color: '#c9a961', fontWeight: '600' }}>Email:</span>{' '}
            <a
              href="mailto:shireenkhan.412@gmail.com"
              style={{
                color: '#c9a961',
                textDecoration: 'none',
                transition: 'all 0.3s ease',
                borderBottom: '1px solid transparent'
              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#d4b56f';
                e.target.style.borderBottomColor = '#d4b56f';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = '#c9a961';
                e.target.style.borderBottomColor = 'transparent';
              }}
            >
              shireenkhan.412@gmail.com
            </a>
          </p>

          <p
            style={{
              margin: 0,
              color: '#8b7355',
              fontFamily: "'Roboto', sans-serif",
              fontSize: '0.85rem',
              textAlign: 'center'
            }}
          >
            © 2024 LawBot. AI-Powered Legal Intelligence for Pakistan.
          </p>
        </div>
      </Container>
    </footer>
  );
}
